export default "__VITE_ASSET__BOcGBNq0__"